import { Button, Select, Spin, Upload, message } from 'antd'
import { useEffect, useRef, useState, useCallback } from 'react'
import { SDrawerOrModal, SGeneralForms, SMessage } from 'shj-components'

import { cloneDeep, debounce } from 'lodash-es'
import styles from './index.module.less'
import { startRefundReSign, orderDetail, startRefundReSignGetOrders } from '@/services/order'
import { UploadOutlined } from '@ant-design/icons'
import { getToken } from 'shj-utils'
import { getXTransferInsideTenantId } from '@/utils/common'
import { baseURL } from '@/api'
interface Iprops {
  title: string
  quoteGoodsId: string
  detailsInfo: Record<string, any>
  open: boolean
  orderId: string
  setOpen: (open: boolean) => void
  fn: () => void
}

export default function DrawerToTab(props: Iprops) {
  const { open, title, setOpen, detailsInfo, orderId } = props
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  const formRef = useRef<any>()
  const formDetailsRef = useRef<any>()
  const formDetailsNewRef = useRef<any>()
  const [options, setOptions] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState<any>([])

  console.log(detailsInfo)

  useEffect(() => {
    if (open) {
      init()
    } else {
      onFormRef()?.resetFields()
    }
  }, [open])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const init = () => {
    orderDetail(orderId).then((res: any) => {
      formRef.current.onFormRef().setFieldsValue({
        originalOrderId: res.id,
      })
      const data = cloneDeep(res)
      data.name = data.quoteGoodsList[0]?.name
      data.stateDisplay = data.quoteGoodsList[0]?.stateDisplay
      formDetailsRef.current.onFormRef().setFieldsValue(data)
    })
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setBtnLoading(true)
        startRefundReSign({ ...values, ignoreWarning: false,
          fileInfos: fileList?.length
            ? fileList?.map(item => {
                return {
                  fileName: item.name,
                  filePath: item.url,
                }
              })
            : null, })
          .then((res: any) => {
            if (res?.hasWarning) {
              SMessage.confirm({
                title: '退单重签发起后，关联的抵扣券将失效，流程撤回，抵扣券也不会恢复',
                content: <span>抵扣券：{res?.couponName}</span>,
                onOk: () => {
                  return startRefundReSign({ ...values, ignoreWarning: true }).then((res: any) => {
                    message.success(res.message || '提交成功')
                    setFileList([])
                    onCancel()
                  })
                },
              })
            } else {
              message.success(res.message || '提交成功')
              setFileList([])
              onCancel()
            }
          })
          .catch((error: any) => {
            message.error(error.message || '提交失败，请重试')
          })
          .finally(() => {
            setBtnLoading(false)
          })
      })
      .catch(() => {
        // 表单验证失败时不需要处理loading状态
      })
  }
  const onCancel = () => {
    onFormRef()?.resetFields()
    setFileList([])
    setOpen(false)
  }
  const getOptions = async () => {
    // const orderList = await startRefundReSignGetOrders({
    //   orderId,
    // })
    // return Promise.resolve({
    //   orderList: orderList,
    // })
  }
  const searchFn = async (userInput: string) => {
    const data: any = await startRefundReSignGetOrders({
      orderId,
      userInput,
      orgId: detailsInfo.orgId,
    })
    console.log(data)
    data.map((item: any) => {
      item.customerName = item.customerName + `【${item.orderNo}】`
    })
    return data
  }

  // 使用useCallback包裹防抖函数
  const debouncedSearch = useCallback(
    debounce(async (value: string) => {
      if (value) {
        try {
          setLoading(true)
          const result = await searchFn(value)
          setOptions(
            result.map((item: any) => ({
              label: item.customerName,
              value: item.orderId,
            }))
          )
        } finally {
          setLoading(false)
        }
      } else {
        setOptions([])
      }
    }, 300),
    [detailsInfo]
  )

  // 组件卸载时取消防抖
  useEffect(() => {
    return () => {
      debouncedSearch.cancel()
    }
  }, [])
  const onbeforeUpload = val => {
    const maxSize = 1024 * 1024 * 50
    if (val && val.size > maxSize) {
      message.warning(val.name + '文件超过50M，上传失败')
      return false
    }
  }
  const onUploadChange = ({ file, fileList }) => {
    let list: any = []
    const maxSize = 1024 * 1024 * 50
    if (file && file.size > maxSize) {
      return
    }
    setFileList([...fileList])
    if (file && file.status === 'done') {
      let data = file.response.data
      list = [
        {
          uid: file?.uid,
          name: data?.originalFilename,
          url: data?.fileUrl,
        },
      ]
      setFileList([...list])
    }
  }
  return (
    <SDrawerOrModal
      title={title}
      open={open}
      onCancel={onCancel}
      destroyOnClose
      width={1010}
      className={styles.second_drawer}
      antdProps={{
        footer: (
          <div style={{ textAlign: 'right' }}>
            <Button loading={btnLoading} style={{ marginRight: '10px' }} onClick={onCancel}>
              取消
            </Button>
            <Button loading={btnLoading} type="primary" onClick={onsubmit}>
              保存
            </Button>
          </div>
        ),
      }}
    >
      <div style={{ margin: '0 10px' }}>
        <SGeneralForms
          ref={formRef}
          //   initialValues={record.id ? { subBusType: record.subBusType } : {}}
          httpOptionsFn={getOptions}
          layout={'vertical'}
          configs={[
            {
              formItem: [
                { name: 'originalOrderId', hidden: true },
                {
                  name: 'reSignOrderId',
                  label: '选择重签订单',
                  required: true,
                  rules: [{ required: true, message: '请选择重签订单' }],
                  spanCol: 13,
                  data: 'orderList',
                  type: 'searchSelect',
                  children: () => {
                    return (
                      <>
                        <Select
                          allowClear
                          showSearch
                          placeholder="请输入客户姓名或订单号选择重签订单"
                          style={{ width: '100%', marginTop: '8px' }}
                          filterOption={false}
                          options={options}
                          onSearch={value => {
                            debouncedSearch(value)
                          }}
                          onSelect={value => {
                            formRef.current.onFormRef().setFieldValue('reSignOrderId', value)
                            orderDetail(value).then((res: any) => {
                              const data = cloneDeep(res)
                              data.name = data.quoteGoodsList[0]?.name
                              data.stateDisplay = data.quoteGoodsList[0]?.stateDisplay
                              formDetailsNewRef.current.onFormRef().setFieldsValue(data)
                            })
                          }}
                          notFoundContent={loading ? <Spin size="small" /> : undefined}
                          defaultOpen={false}
                        />
                        <div
                          style={{
                            fontSize: '12px',
                            color: '#888',
                            marginTop: '8px',
                            marginLeft: '5px',
                          }}
                        >
                          注意：重签订单需主合同客户已签字确认才可选择
                        </div>
                      </>
                    )
                  },
                },
                {
                  spanCol: 13,
                  label: '备注',
                  name: 'reasonDescription',
                  type: 'textarea',
                  required: true,
                  comConfig: { showCount: true, maxLength: 200 },
                },
                {
                  spanCol: 13,
                  label: '附件',
                  children: (
                    <Upload
                      headers={{
                        Authorization: getToken?.(),
                        'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId(),
                      }}
                      accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.md,.jpg,.jpeg,.gif,.bmp,.png,.tiff,.psd"
                      action={baseURL + `file-web/file/upload`}
                      fileList={fileList}
                      beforeUpload={onbeforeUpload}
                      onChange={onUploadChange}
                      maxCount={1}
                      // onPreview={onPreview}
                    >
                      <Button icon={<UploadOutlined />}>上传附件</Button>
                       <p style={{ color: 'rgb(153, 153, 153)' }}>单个文件大小不能超过50M</p>
                    </Upload>
                  ),
                },
              ],
            },
          ]}
        />
      </div>
      <div style={{ display: 'flex', borderTop: '1px solid #EEEEEE' }}>
        <SGeneralForms
          ref={formDetailsRef}
          //   detailsData={}
          isDetail={true}
          configs={[
            {
              formItem: [
                {
                  name: 'channelName',
                  label: '原订单信息',
                  spanCol: 24,
                },
                {
                  name: 'orderNo',
                  label: '订单号',
                  spanCol: 24,
                },
                {
                  name: 'statusDisplay',
                  label: '订单状态',
                  spanCol: 24,
                },
                {
                  name: 'customerName',
                  label: '客户姓名',
                  spanCol: 24,
                },
                {
                  name: 'customerPhone',
                  label: '手机号',
                  spanCol: 24,
                },
                {
                  name: 'name',
                  label: '商品名称',
                  spanCol: 24,
                },
                {
                  name: 'bizTagDisplay',
                  label: '需求标签',
                  spanCol: 24,
                },
                {
                  name: 'stateDisplay',
                  label: '商品状态',
                  spanCol: 24,
                },
                {
                  name: 'totalPrice',
                  label: '金额',
                  spanCol: 24,
                },
              ],
            },
          ]}
        />
        <SGeneralForms
          style={{ borderTop: '1px solid #EEEEEE' }}
          ref={formDetailsNewRef}
          //   detailsData={}
          isDetail={true}
          configs={[
            {
              formItem: [
                {
                  name: 'cooperateModeName',
                  label: '重签订单信息',
                  spanCol: 24,
                },
                {
                  name: 'orderNo',
                  label: '订单号',
                  spanCol: 24,
                },
                {
                  name: 'statusDisplay',
                  label: '订单状态',
                  spanCol: 24,
                },
                {
                  name: 'customerName',
                  label: '客户姓名',
                  spanCol: 24,
                },
                {
                  name: 'customerPhone',
                  label: '手机号',
                  spanCol: 24,
                },
                {
                  name: 'name',
                  label: '商品名称',
                  spanCol: 24,
                },
                {
                  name: 'bizTagDisplay',
                  label: '需求标签',
                  spanCol: 24,
                },
                {
                  name: 'stateDisplay',
                  label: '商品状态',
                  spanCol: 24,
                },
                {
                  name: 'totalPrice',
                  label: '金额',
                  spanCol: 24,
                },
              ],
            },
          ]}
        />
      </div>
    </SDrawerOrModal>
  )
}
